// Soumission compatible Netlify Forms.
// On poste vers "/__forms.html", un fichier statique reel qui contient les
// definitions de formulaires. Cela evite que la regle SPA (/* -> /404.html)
// n'interfere avec la capture de la soumission par Netlify.
// En previsualisation, ce POST ne declenche pas le gestionnaire Netlify ;
// l'application bascule alors vers les pages /merci-* (repli dev).
const FORM_ENDPOINT = "/__forms.html";

export function encodeForm(data) {
  return Object.keys(data)
    .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(data[k] ?? ""))
    .join("&");
}

// Soumission simple (sans fichier), url-encodee.
export async function submitNetlifyForm(formName, data) {
  const body = encodeForm({ "form-name": formName, ...data });
  const res = await fetch(FORM_ENDPOINT, {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body,
  });
  if (!res.ok) throw new Error("network");
  return true;
}

// Soumission multipart (avec piece jointe facultative).
export async function submitNetlifyMultipart(formName, data, file) {
  const fd = new FormData();
  fd.append("form-name", formName);
  Object.keys(data).forEach((k) => fd.append(k, data[k] ?? ""));
  if (file) fd.append("attachment", file);
  const res = await fetch(FORM_ENDPOINT, { method: "POST", body: fd });
  if (!res.ok) throw new Error("network");
  return true;
}
